import React, {useState} from 'react';
import styles from './styles';
import {btn_c_fadeToHighlight} from '@xpertdox_js/xdstyle';
import {IconTextButton, ModalContainer} from '@xpertdox_js/xdcomponents';
import EditableField from '../../../OverviewContainer/EditableField';
import dataTableSetting from '../../../TrialUI/dataTableSettings';
import MsgBanner from '../../../msgBanner';
import {UserContext} from "../../../../Context/UserContext";
import config from '../../../../config/axios.config';
import {XtMessagePortal, ConsoleMessagePortal} from '../../../Common/xdcomponents';

const headerObj = dataTableSetting.headers;

const ContactTime = (props) => <div>
  {props.data ?
    (
      <div>
        {Object.keys(props.data).map(day => <p>
          {(props.data[day][0] || props.data[day][1]) && <b style={{textTransform: "capitalize"}}>{day}</b>}
          {props.data[day][0] && <span> {props.data[day][0].label}</span>}
          {props.data[day][1] && <span> to {props.data[day][1].label}</span>}
        </p>)}
      </div>
    ) : 'N/A'
  }
</div>


const PatientInformation = props => {
  const [showModal, setShowModal] = useState(false);
  const { user } = React.useContext(UserContext)
  const {
    firstName, mrn, email, telephone, age, displayDate,
    pscore, mutationsIN, mutationsOUT, gender, preferredDayTime,
    platform, sendersName, sendersEmail, comments, triage, notesForTeam
  } = props.data;

  const content = [
    {
      title: 'Source',
      diffProperty: 'platform',
      value: platform,
      editable: false,
      tooltip: headerObj.source.tip
    },
    {
      title: 'Date of Referral',
      diffProperty: 'created_date',
      value: displayDate + ' CST',
      editable: false,
      tooltip: "Date and time this registration was made."
    },
    {
      title: 'Patient Name',
      diffProperty: 'name',
      value: firstName,
      formSettings: [{
        type: 'text',
        value: props.diff.name || firstName,
      }],
      tooltip: headerObj.patName.tip
    },
    {
      title: 'MRN (XpertScreen)',
      diffProperty: 'mrn',
      value: mrn,
      formSettings: [{
        type: 'text',
        value: props.diff.mrn || mrn,
      }],
      tooltip: headerObj.mrn.tip
    },
    {
      title: 'Patient Email',
      diffProperty: 'email',
      value: email,
      formSettings: [{
        type: 'email',
        value: props.diff.email || email,
      }],
      tooltip: headerObj.patEmail.tip
    },
    {
      title: 'Telephone',
      diffProperty: 'telephone',
      value: telephone,
      formSettings: [{
        type: 'phone',
        value: props.diff.telephone || telephone,
      }],
      tooltip: headerObj.patPhone.tip
    },
    {
      title: 'Age',
      diffProperty: 'age',
      value: age,
      formSettings: [{
        type: 'number',
        value: props.diff.age || age,
      }],
      tooltip: headerObj.age.tip
    },
    {
      title: 'Gender',
      diffProperty: 'gender',
      value: gender,
      formatDisplay: value => {
        if (value === 'M') return 'Male';
        if (value === 'F') return 'Female';
        if (value === 'M, F') return 'Other';
      },
      formSettings: [{
        type: 'select',
        options: [['Male', 'M'], ['Female', 'F'], ['Other', 'M, F']],
        value: props.diff.gender || gender,
      }],
      tooltip: headerObj.gender.tip
    },
    {
      title: 'Performance Status of the Patient (XpertTrial)',
      diffProperty: 'pscore',
      value: pscore,
      formatDisplay: (value) => {
        if (value) {
          let displayValue = '0';
          const parsedValue = parseInt(value);
          if (parsedValue > 0) displayValue += ', 1';
          if (parsedValue > 1) displayValue += ', 2';
          if (parsedValue > 2) displayValue += ', 3';
          if (parsedValue > 3) displayValue += ', 4';
          return displayValue;
        } else {
          return value;
        }
      },
      formSettings: [{
        type: 'select',
        value: props.diff.pscore || pscore,
        options: [0, 1, 2, 3, 4],
      }],
      tooltip: headerObj.pscore.tip
    },
    {
      title: 'Mutations Present (XpertTrial)',
      diffProperty: 'mutationsIN',
      value:  (mutationsIN && mutationsIN.length ? mutationsIN : null),
      valueToCompare: props.diff.mutationsOUT || mutationsOUT || [],
      formSettings: [{
        type: 'multiselect',
        value: props.diff.mutationsIN || (mutationsIN && mutationsIN.length ? mutationsIN : null),
        options: props.filters.mutations,
      }],
      tooltip: headerObj.mutationsIn.tip
    },
    {
      title: 'Mutations Absent (XpertTrial)',
      diffProperty: 'mutationsOUT',
      value:  (mutationsOUT && mutationsOUT.length ? mutationsOUT : null),
      valueToCompare: props.diff.mutationsIN || mutationsIN || [],
      formSettings: [{
        type: 'multiselect',
        value: props.diff.mutationsOUT || (mutationsOUT && mutationsOUT.length ? mutationsOUT : null),
        options: props.filters.mutations
      }],
      tooltip: headerObj.mutationsOut.tip
    },
    {
      title: "Sender's Name (XpertScreen)",
      diffProperty: 'platform',
      value: sendersName,
      editable: false,
      tooltip: headerObj.senderName.tip
    },
    {
      title: "Sender's Email (XpertScreen)",
      diffProperty: 'platform',
      value: sendersEmail,
      editable: false,
      tooltip: headerObj.senderEmail.tip
    },
    {
      title: 'Note for study team',
      diffProperty: 'notesForTeam',
      value: notesForTeam || '',
      formSettings: [{
        type: 'textarea',
        value: props.diff.notesForTeam || notesForTeam,
        options: {submitOnEnter: true}
      }],
      editable: false,
      tooltip: 'Note for study team made by the referring provider'
    },
    {
      title: 'Triage',
      diffProperty: 'triage',
      value:  triage,
      formSettings: [{
        type: 'select',
        value: props.diff.triage || triage,
        options: [
          'Inbox',
          'Pi Contacted',
          'Patient Contacted',
          // 'Pre Screen Pass',
          // 'Pre Screen Fail',
          // 'Enrolled',
          // 'No PI Contact',
          // 'No Patient Contact',
          'Exported',
          'Archived',
        ]
      }],
      tooltip: headerObj.status.tip
    },
    {
      title: 'Preferred Contact Times (XpertTrial)',
      diffProperty: 'platform',
      value: preferredDayTime,
      editable: false,
      customDisplayField: () => (<ContactTime
        data={preferredDayTime}
      />),
      tooltip: 'The times the patient prefers to be contacted during the week. This is given at time of submission.'
    },
    {
      title: 'Comments',
      diffProperty: 'comments',
      value: comments || '',
      formSettings: [{
        type: 'textarea',
        value: props.diff.comments || comments,
        options: {submitOnEnter: true}
      }],
      tooltip: headerObj.patComments.tip
    },
  ]

  return (
    <div style={styles.container}>
      <MsgBanner type='editField' removable user={user}/>
      <div style={styles.editPanel}>
        {content.map((settings, i) => <EditableField
            setValue={props.setDiff}
            key={i}
            index={i}
            length={content.length - 1}
            diff={props.diff[settings.diffProperty]}
            settings={settings}
            zIndex={content.length - i}
            width={props.width}
          />
        )}
      </div>
      {/*!showModal && <IconTextButton
        icon='broadcast'
        onClick={() => setShowModal(true)}
        size='md'
        preBuiltStyles={btn_c_fadeToHighlight}
        styles={styles.sendMessageButton}
        text='Send Message to Patient'
      />*/}
      {/*<ModalContainer
        open={showModal}
        showOverlay={showModal}
        close={() => setShowModal(false)}
        width='840px'
        maxWidth={window.innerWidth * .8}
      >*/}
      {showModal && <React.Fragment>
          <ConsoleMessagePortal
            user={user}
            nct={props.nct || (props.data && props.data.nct_id)}
            patientId={props.patientId}
            instance='STANFORD'
            apiUrl={config.apiUrl}
            headers={config.auth.headers}
          />
          {/*<XtMessagePortal
            user={user}
            nct={props.nct || (props.data && props.data.nct_id)}
            instance='STANFORD'
            apiUrl={config.apiUrl}
            headers={config.auth.headers}
          />*/}
        </React.Fragment>
      }
      {/*</ModalContainer>*/}
    </div>
  )
}

export default PatientInformation;
